import { render, staticRenderFns } from "./enrollmentGuide.vue?vue&type=template&id=fab10640&scoped=true"
import script from "./enrollmentGuide.vue?vue&type=script&lang=js"
export * from "./enrollmentGuide.vue?vue&type=script&lang=js"
import style0 from "./enrollmentGuide.vue?vue&type=style&index=0&id=fab10640&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab10640",
  null
  
)

export default component.exports